import React from 'react';
import Editor from '../../../components/Editor';
import { EditorProvider } from '../../../components/Editor/EditorContext';

const NewNote = () => (
  <EditorProvider>
    <Editor />
  </EditorProvider>
);

export default NewNote;
